import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { setParams } from './url';
var CheckPageUpdate = /*#__PURE__*/function () {
  /**
   * 解决页面缓存和离线包更新问题
   * @classdesc CheckPageUpdate
   * @constructs CheckPageUpdate
   * @param {Object} options 配置项
   * @param {String} options.timer 循环的时间，默认一分钟
   * @see [需求文档](https://dashen.zhuanspirit.com/pages/viewpage.action?pageId=507855376&from_wecom=1)
   * @example
   import { CheckPageUpdate } from '@zz-common/zz-utils'
  try {
  //实例化该类
      const checkPage = new CheckPageUpdate({
          timer: 60000 // 默认一分钟检测一次
      })
      //未更新通知
      checkPage.on('no-update',()=>{
          // console.log('no update')
      })
      //更新通知
      checkPage.on('update',()=>{
          // 可以做一个弹框提示用户是否更新了
          // 刷新页面请使用checkPage.reloadPage() 方法，reloadPage方法会在url上添加一个zzIgnoringLocalCacheTs，客户端检测到这个参数，会停用离线包和刷新离线包
          checkPage.reloadPage()  
      })
  } catch (error) {
      console.log(error)
  }
  */
  function CheckPageUpdate(options) {
    _classCallCheck(this, CheckPageUpdate);
    this.oldScript = []; //存储第一次值也就是script 的hash 信息
    this.newScript = []; //获取新的值 也就是新的script 的hash信息
    this.dispatch = {}; //小型发布订阅通知用户更新了
    this.init(); //初始化
    this.timing(options.timer); //轮询
  }
  _createClass(CheckPageUpdate, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var html;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getHtml();
            case 2:
              html = _context.sent;
              this.oldScript = this.parserScript(html);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "getHtml",
    value: function () {
      var _getHtml = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var html;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return fetch(location.origin + location.pathname + '?' + +new Date()).then(function (res) {
                return res.text();
              })["catch"](function (err) {
                // console.log(err)
              });
            case 3:
              html = _context2.sent;
              return _context2.abrupt("return", html);
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", '');
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 7]]);
      }));
      function getHtml() {
        return _getHtml.apply(this, arguments);
      }
      return getHtml;
    }()
  }, {
    key: "parserScript",
    value: function parserScript(html) {
      var reg = new RegExp(/<script(?:\s+[^>]*)?>(.*?)<\/script\s*>/ig); //script正则
      return html.match(reg) ? html.match(reg) : []; //匹配script标签
    }

    /**
     * 订阅事件
     * @method on
     * @memberof CheckPageUpdate
     * @param {String} key 事件名
     * @param {Function} fn 事件回调
     * @example
     * checkPage.on('update',()=>{
     * //do something
     * })
     * checkPage.on('no-update',()=>{
     * //do something
     * })
     **/
  }, {
    key: "on",
    value: function on(key, fn) {
      (this.dispatch[key] || (this.dispatch[key] = [])).push(fn);
      return this;
    }
  }, {
    key: "compare",
    value: function compare(oldArr, newArr) {
      var base = oldArr.length;
      var arr = Array.from(new Set(oldArr.concat(newArr)));
      //如果新旧length 一样无更新
      if (arr.length === base) {
        this.dispatch['no-update'].forEach(function (fn) {
          fn();
        });
        return false;
      } else {
        //否则通知更新
        this.dispatch['update'].forEach(function (fn) {
          fn();
        });
        return true;
      }
    }
  }, {
    key: "timing",
    value: function timing() {
      var _this = this;
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60000;
      //轮询
      this.timer = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var newHtml;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this.getHtml();
            case 2:
              newHtml = _context3.sent;
              _this.newScript = _this.parserScript(newHtml);
              _this.compare(_this.oldScript, _this.newScript);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })), time);
    }
    /**
     * 刷新页面
     * @method reloadPage
     * @memberof CheckPageUpdate
     * @example
     * checkPage.reloadPage()
     */
  }, {
    key: "reloadPage",
    value: function reloadPage() {
      // 在现在有url上添加zzIgnoringLocalCacheTs=时间戳，要保持url上原有的参数不丢失
      var url = setParams({
        'zzIgnoringLocalCacheTs': +new Date()
      }, location.href);
      window.location.replace(url);
    }
    /**
     * 立即检查
     * @method check
     * @memberof CheckPageUpdate
     * @example
     * checkPage.check().then(res => console.log(res))
     * @returns {Boolean} true 无更新 false 有更新
     * 同时监听也会触发
     * */
  }, {
    key: "check",
    value: (function () {
      var _check = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var newHtml;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.getHtml();
            case 2:
              newHtml = _context4.sent;
              this.newScript = this.parserScript(newHtml);
              return _context4.abrupt("return", this.compare(this.oldScript, this.newScript));
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function check() {
        return _check.apply(this, arguments);
      }
      return check;
    }()
    /**
     * 停止轮询
     * @method stop
     * @memberof CheckPageUpdate
     * @example
     * checkPage.stop()
     * */
    )
  }, {
    key: "stop",
    value: function stop() {
      //停止轮询
      clearInterval(this.timer);
    }
    /**
     * 重新开始
     * @method restart
     * @memberof CheckPageUpdate
     * @example
     * checkPage.restart()
     * */
  }, {
    key: "restart",
    value: function restart() {
      var timer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60000;
      //重新开始
      this.stop();
      this.timing(timer);
    }
  }]);
  return CheckPageUpdate;
}();
export default CheckPageUpdate;